import { render } from "./ArtworkRequestCard.vue?vue&type=template&id=629382a0&scoped=true"
import script from "./ArtworkRequestCard.vue?vue&type=script&lang=js"
export * from "./ArtworkRequestCard.vue?vue&type=script&lang=js"

import "./ArtworkRequestCard.vue?vue&type=style&index=0&id=629382a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629382a0"]])

export default __exports__